import MediaQuery from 'react-responsive';
import { hourFormat, shortDateFormat } from '@paradigm/utils/src/date';

import {
  GrfqTrade,
  GrfqTradeTape,
} from '@paradigm/features/src/unified-rfqs/entities/grfq/domain';
import { useFormattedGrfqMakerPrice } from '@paradigm/features/src/unified-rfqs/ui/hooks/useFormattedPrice';
import { useTradeDetailsView } from '@paradigm/features/src/unified-rfqs/ui/trades/details-view';
import ColoredStrategyDescription from '#/components/UnifiedRfqs/components/strategy-description/ColoredStrategyDescription';
import {
  Container,
  DateInfo,
  getSideText,
  TradeInfoGrid,
  Label,
  TagSpan,
} from '#/components/UnifiedRfqs/components/DetailsModal';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

function isRejected(trade: GrfqTrade | GrfqTradeTape) {
  return (trade as GrfqTrade).rejected_reason != null;
}

export default function GrfqTradeDescription({
  trade,
}: {
  trade: GrfqTrade | GrfqTradeTape;
}) {
  const { side } = useTradeDetailsView();
  const formattedPrice = useFormattedGrfqMakerPrice({
    price: trade.price,
    side,
    productCode: trade.product_codes[0],
    description: trade.description,
    /* if is from trade tape it is the taker side */
    isTaker: 'desk_role' in trade ? trade.desk_role === 'Taker' : true,
  });

  return (
    <Container aria-label="trade description">
      <TradeInfoGrid>
        {!isRejected(trade) && getSideText(trade.action ?? null)}

        <MediaQuery minWidth={MOBILE_BREAKPOINT}>
          <TagSpan>
            <ColoredStrategyDescription>
              {trade.description}
            </ColoredStrategyDescription>
          </TagSpan>
        </MediaQuery>

        <Label>at</Label>
        <div css="text-align: left;">
          <TagSpan>{formattedPrice}</TagSpan>
          <span>{trade.quote_currency}</span>
        </div>
      </TradeInfoGrid>

      <MediaQuery minWidth={MOBILE_BREAKPOINT}>
        <DateInfo>
          <p>{hourFormat(trade.traded)}</p>
          <p>{shortDateFormat(trade.traded)}</p>
        </DateInfo>
      </MediaQuery>
    </Container>
  );
}
